import { render, staticRenderFns } from "./mucWorkCriterionProfileForm.vue?vue&type=template&id=e289c012&scoped=true&"
import script from "./mucWorkCriterionProfileForm.vue?vue&type=script&lang=js&"
export * from "./mucWorkCriterionProfileForm.vue?vue&type=script&lang=js&"
import style0 from "./mucWorkCriterionProfileForm.vue?vue&type=style&index=0&id=e289c012&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e289c012",
  null
  
)

export default component.exports